let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a8heY")).then(() => parcelRequire('aFb9z'));